var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPayouts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6772 4.39328C18.6772 3.57687 19.339 2.91504 20.1554 2.91504H28.5177C29.3341 2.91504 29.9959 3.57687 29.9959 4.39328L29.9959 12.7555C29.9959 13.5719 29.3341 14.2337 28.5177 14.2337C27.7012 14.2337 27.0394 13.5719 27.0394 12.7555L27.0394 7.97991L20.9733 14.046C20.9716 14.0477 20.9699 14.0494 20.9683 14.051C20.9614 14.0582 20.9545 14.0652 20.9474 14.0723C20.1956 14.8241 19.351 15.4196 18.4855 15.8882C19.2759 16.3778 19.9939 16.9925 20.7326 17.7153C20.7524 17.7335 20.772 17.7522 20.7913 17.7715L27.0178 23.998V19.163C27.0178 18.3395 27.6854 17.6719 28.5089 17.6719C29.3324 17.6719 30 18.3395 30 19.163V27.5979C30 28.4214 29.3324 29.089 28.5089 29.089L20.0741 29.089C19.2505 29.089 18.583 28.4214 18.583 27.5979C18.583 26.7744 19.2505 26.1068 20.0741 26.1068L24.9092 26.1068L18.8566 20.0542C18.8506 20.0484 18.8446 20.0425 18.8387 20.0366C17.7713 18.9692 17.0032 18.3839 16.151 18.0288C15.2942 17.6718 14.2149 17.4912 12.4376 17.4912L3.49109 17.4912C2.66758 17.4912 2 16.8236 2 16.0001C2 15.1766 2.66758 14.509 3.49109 14.509L12.4376 14.509C13.7195 14.509 16.8413 13.9609 18.8387 11.9635L18.8424 11.9598C18.8497 11.9523 18.8571 11.9448 18.8646 11.9373L24.9304 5.87153L20.1554 5.87153C19.339 5.87153 18.6772 5.2097 18.6772 4.39328Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayouts);
export default __webpack_public_path__ + "static/media/payouts.d1127b042bb92e0b00e60a7704ff6f54.svg";
export { ForwardRef as ReactComponent };